import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { FieldSet } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import { Icon } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { actualizarModal, actualizaSubModal } from '../../../store/channelmap/reporteconstruccion/actions';
import NativeSelect from '@material-ui/core/NativeSelect';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
    },
    wrap: {
        flex: '1 1 auto',
    },
    modal: {
        top: '50%',
        left: '50%',
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        maxHeight: 500,
        maxWidth: 800,
        width: '100%',
        display: 'block',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 0, 1, 5),
        alignItems: 'center',
        justifyContent: 'center',
        '@media (max-width: 780px)': {
            width: '80%',
            fontSize: 'max(1.5vw, 5px)',
        },
        '@media (max-width: 865px)': {
            width: '80%',
            fontSize: 'max(1.5vw, 5px)',
        },
        '@media (max-width: 425px)': {
            width: '85%',
            fontSize: 'max(2.5vw, 5px)',
        },
        '@media (max-width: 375px)': {
            width: '85%',
            fontSize: 'max(3.5vw, 5px)',
        },
        '@media (max-width: 320px)': {
            width: '85%',
            fontSize: 'max(3.5vw, 5px)',
        },
        borderRadius: '15px',
    },
    summary: {
        fontWeight: 700,
        backgroundColor: 'rgba(0,102,255,.25)',
    },
    bot: {
        position: 'fixed',
        marginTop: '60px',
        marginLeft: '125px',
        left: '75%',

        '@media (max-width: 1024px)': {
            marginTop: '-5px',
            marginLeft: '120px',
        },
        '@media (max-width: 768px)': {
            marginTop: '30px !important',
            marginLeft: '87px',
            fontSize: '10px',
        },
        '@media (max-width: 425px)': {
            marginTop: '10px !important',
            marginLeft: '20px !important',
            fontSize: '9px',
        },
        '@media (max-width: 375px)': {
            marginTop: '18px !important',
            marginLeft: '10px !important',
            fontSize: '9px',
        },
        '@media (max-width: 320px)': {
            marginTop: '30px !important',
            marginLeft: '-1px !important',
            fontSize: '10px !important',
        },
    },
    btnPluss: {
        maxWidth: '18px',
        maxHeight: '15px',
        minWidth: '18px',
        minHeight: '14px',
        marginLeft: '20',
        paddingLeft: '10px',
        fontWeight: '10px',
    },
    cuadro: {
        overflow: 'auto',
        height: '250px',
        width: '690px',
        maxWidth: '700px',
        marginBottom: '20px !important',
        '@media (max-width: 768px)': {
            width: '100%',
            height: '220px !important',
            fontSize: 'max(1vw, 5px)',
            marginTop: '-5px !important',
            marginLeft: '-70px',
            marginBottom: '-20px',
        },
        '@media (max-width: 425px)': {
            width: '110%',
            height: '220px !important',
            fontSize: 'max(1vw, 5px)',
            marginTop: '-5px !important',
            marginLeft: '-70px',
            marginBottom: '-20px',
        },
        '@media (max-width: 375px)': {
            width: '110%',
            height: '200px !important',
            fontSize: 'max(1vw, 5px)',
            marginTop: '-15px !important',
            marginLeft: '-70px',
            marginBottom: '-30px',
        },
        '@media (max-width: 320px)': {
            width: '110%',
            height: '200px !important',
            marginTop: '-6px',
            marginLeft: '-70px',
        },
    },
    resul: {
        fontSize: '10px !important',
        background: 'white ',
        textAlign: 'Left !important',
    },
    resuld: {
        fontSize: '10px !important',
        textAlign: 'Right !important',
        background: 'white ',
    },
    nav: {
        '@media (max-width: 320px)': {
            marginTop: ' 28px !important',
            marginLeft: '300px !important',
        },
        '@media (max-width: 375px)': {
            marginTop: ' 30px !important',
            marginLeft: '300px !important',
        },
        '@media (max-width: 425px)': {
            marginTop: ' 30px !important',
            marginLeft: '-245px !important',
        },
    },
    nav1: {
        '@media (max-width: 320px)': {
            marginLeft: '250px !important',
        },
        '@media (max-width: 375px)': {
            marginLeft: '252px !important',
        },
        '@media (max-width: 425px)': {
            marginLeft: '252px !important',
        },
    },
    tblPrincipal: {
        paddingLeft: 70,
        paddingtop: 40,

        '@media (max-width: 1024px)': {
            paddingLeft: '20px !important',
            width: '95% !important',
            overflowY: 'hidden',
        },
        '@media (max-width: 768px)': {
            width: '92% !important',
            overflowY: 'hidden',
            paddingLeft: '30px !important',
        },

        '@media (max-width: 425px)': {
            width: '92% !important',
            overflowY: 'hidden',
            paddingLeft: '30px !important',
        },
        '@media (max-width: 375px)': {
            width: '92% !important',
            overflowY: 'hidden',
            paddingLeft: '30px !important',
        },
        '@media (max-width: 320px)': {
            width: '89% !important',
            overflowY: 'hidden',
            paddingLeft: '30px !important',
        },
    },
}));

const ReporteConstruccionList = () => {
    const classes = useStyles();
    const data = useSelector((state) => state.reporteconstruccion.data);
    const modal = useSelector((state) => state.reporteconstruccion.detalleModal);
    const modal1 = useSelector((state) => state.reporteconstruccion.detalleModal1);

    const [datosAgrupados, setDatosAgrupados] = useState([]);
    const [summary, setSummary] = useState({});
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState({});
    const loading = useSelector((state) => state.reportepedidos.loading);
    const HandleClose = () => setOpen(false);
    const dispatch = useDispatch();
    const [estado, setEstado] = useState('');

    const handleGeneral = (props) => {
        setEstado('TODOS');
        dispatch(actualizarModal(props));
        setOpen(true);
        setTitle(props);
    };

    useEffect(() => {
        if (data.length >= 1) {
            // Agrupar por dSegmento y sumar valores
            const agrupado = data.reduce((acumulador, item) => {
                const segmento = item.dSegmento;

                if (!acumulador[segmento]) {
                    acumulador[segmento] = {
                        dSegmento: segmento,
                        cuentaPDV: 0,
                        mercadoPDV: 0,
                        galones: 0,
                        galonesMercado: 0,
                    };
                }

                acumulador[segmento].cuentaPDV += item.cuentaPDV || 0;
                acumulador[segmento].mercadoPDV += item.mercadoPDV || 0;
                acumulador[segmento].galones += item.galones || 0;
                acumulador[segmento].galonesMercado += item.galonesMercado || 0;

                return acumulador;
            }, {});

            // Convertir objeto a array
            const datosAgrupadosArray = Object.values(agrupado);
            setDatosAgrupados(datosAgrupadosArray);

            // Calcular totales generales
            setSummary({
                cuentaPDV: datosAgrupadosArray.reduce((sum, item) => sum + (item.cuentaPDV || 0), 0),
                mercadoPDV: datosAgrupadosArray.reduce((sum, item) => sum + (item.mercadoPDV || 0), 0),
                galones: datosAgrupadosArray.reduce((sum, item) => sum + (item.galones || 0), 0),
                galonesMercado: datosAgrupadosArray.reduce((sum, item) => sum + (item.galonesMercado || 0), 0),
            });
        }
    }, [data]);

    useEffect(() => {}, [modal]);

    function onChange(event) {
        setEstado(event.target.value);
        if (event.target.value === 'CLIENTE' || event.target.value === 'PROSPECTO' || event.target.value === 'CLIENTE S/C') {
            var mostrar = modal1.filter((f) => f.tipo === event.target.value);
            dispatch(actualizaSubModal(mostrar));
        } else {
            dispatch(actualizaSubModal(modal1));
        }
    }
    
    const ModalContent = () => {
        return (
            <div>
                <Modal fullscreen={'xxl'} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" open={open} onClose={HandleClose}>
                    <div className={classes.outer}>
                        <div className={classes.modal} style={{ height: 'auto', minHeight: '400px', maxHeight: '600px', padding: '20px' }}>
                            <h2 style={{ textAlign: 'center', marginBottom: '20px', marginTop: 0 }}>Detalle de Clientes</h2>

                            {/* Contenedor principal con ancho fijo */}
                            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                                {/* Header con Canal y Filtro */}
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '15px',
                                    }}
                                >
                                    <div style={{ fontSize: '14px' }}>
                                        CANAL: <b>{title.dSegmento}</b>
                                    </div>

                                    <div
                                        style={{
                                            border: '1px solid #C4C4C4',
                                            borderRadius: '5px',
                                            minWidth: '150px',
                                        }}
                                    >
                                        <NativeSelect
                                            id="lang"
                                            onChange={onChange}
                                            style={{
                                                width: '100%',
                                                border: 'none',
                                                padding: '5px 10px',
                                            }}
                                            value={estado}
                                        >
                                            <option value="TODOS">Todos</option>
                                            <option value="CLIENTE">Cliente</option>
                                            <option value="PROSPECTO">Prospecto</option>
                                            <option value="CLIENTE S/C">Cliente S/C</option>
                                        </NativeSelect>
                                    </div>
                                </div>

                                {/* Total de registros */}
                                <div
                                    style={{
                                        textAlign: 'right',
                                        marginBottom: '10px',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Total: {modal.length}
                                </div>

                                {/* Tabla con scroll */}
                                <div
                                    style={{
                                        overflow: 'auto',
                                        height: '300px',
                                        marginBottom: '20px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                    }}
                                >
                                    <table
                                        className="aprobacion"
                                        id="tableMod"
                                        style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th style={{ width: '50%', padding: '8px', textAlign: 'left' }}>Nombre de Cliente</th>
                                                <th style={{ width: '25%', padding: '8px', textAlign: 'center' }}>Tipos</th>
                                                <th style={{ width: '25%', padding: '8px', textAlign: 'right' }}>Galones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modal.length === 0 ? (
                                                <tr>
                                                    <td colSpan="3" style={{ border: 'none', textAlign: 'center', padding: '20px' }}>
                                                        No existe registros para esta consulta
                                                    </td>
                                                </tr>
                                            ) : (
                                                modal.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className={classes.resul} style={{ padding: '8px' }}>
                                                                {item.cliente}
                                                            </td>
                                                            <td className={classes.resuld} style={{ padding: '8px', textAlign: 'center' }}>
                                                                {item.tipo}
                                                            </td>
                                                            <td className={classes.resuld} style={{ padding: '8px', textAlign: 'right' }}>
                                                                {item.tGalones}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                        {loading && (
                                            <tbody>
                                                <tr>
                                                    <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
                                                        <img
                                                            alt="log"
                                                            src="https://app.iess.gob.ec/iess-fondo-reserva-afiliado-web/javax.faces.resource/images/load.gif.jsf;jsessionid=8949b76cfea43d283add3bd3dd2d?ln=sentinel-layout"
                                                            width="40"
                                                            height="40"
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )}
                                    </table>
                                </div>

                                {/* Botón Cerrar */}
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button variant="contained" color="primary" onClick={HandleClose}>
                                        Cerrar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    };

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tblPrincipal}>
                <div style={{ display: 'none' }}>
                    <ReactHTMLTableToExcel id="table-xls-button-rpt-indicadores" className="" table="table-to-xls" filename="Rpt_Indicadores" sheet="Indicadores" buttonText="" />
                </div>
                <table id="table-to-xls" style={{ width: 940 }}>
                    <thead>
                        <tr>
                            <th rowSpan="3" style={{ backgroundColor: '#BFD9FF' }}>
                                CANAL
                            </th>
                            <th colSpan="4" style={{ backgroundColor: '#BFD9FF' }}>
                                # DE PUNTOS DE VENTA
                            </th>
                            <th colSpan="4" style={{ backgroundColor: '#F3F781' }}>
                                GALONES / MES
                            </th>
                        </tr>
                        <tr>
                            <th colSpan="3" style={{ backgroundColor: '#BFD9FF' }}>
                                COBERTURA
                            </th>
                            <th style={{ backgroundColor: '#BFD9FF' }}>%</th>
                            <th colSpan="3" style={{ backgroundColor: '#F3F781' }}>
                                PARTICIPACIÓN
                            </th>
                            <th style={{ backgroundColor: '#F3F781' }}>%</th>
                        </tr>
                        <tr>
                            <th style={{ backgroundColor: '#BFD9FF' }}>Puntos Actuales</th>
                            <th style={{ backgroundColor: '#BFD9FF' }}>Puntos Mercado</th>
                            <th style={{ backgroundColor: '#BFD9FF' }}>Cobertura</th>
                            <th style={{ backgroundColor: '#BFD9FF' }}>Puntos Potenciales</th>
                            <th style={{ backgroundColor: '#F3F781' }}>Actual</th>
                            <th style={{ backgroundColor: '#F3F781' }}>Mercado</th>
                            <th style={{ backgroundColor: '#F3F781' }}>Participación</th>
                            <th style={{ backgroundColor: '#F3F781' }}>Potencial</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datosAgrupados.map((d, index) => (
                            <tr key={`rpt-${index}`}>
                                <td style={{ textAlign: 'left' }}>
                                    <Button
                                        className={classes.btnPluss}
                                        size="small"
                                        startIcon={<Icon className="fa fa-plus-circle" />}
                                        onClick={() =>handleGeneral({ dSegmento: d.dSegmento, })}
                                    />
                                    {d.dSegmento}
                                </td>
                                <td style={{ textAlign: 'right' }}>{d.cuentaPDV ? d.cuentaPDV : 0}</td>
                                <td style={{ textAlign: 'right' }}>{d.mercadoPDV ? d.mercadoPDV : 0}</td>
                                <td style={{ textAlign: 'right' }}>{((parseFloat(d.mercadoPDV) === 0 ? 0.0 : d.cuentaPDV / d.mercadoPDV) * 100).toFixed(2)}%</td>
                                <td style={{ textAlign: 'right' }}>{d.mercadoPDV - d.cuentaPDV}</td>
                                <td style={{ textAlign: 'right' }}>{d.galones ? Intl.NumberFormat('es-MX').format(d.galones) : 0}</td>
                                <td style={{ textAlign: 'right' }}>{d.galonesMercado ? Intl.NumberFormat('es-MX').format(d.galonesMercado) : 0}</td>
                                <td style={{ textAlign: 'right' }}>{((parseFloat(d.galonesMercado) === 0 ? 0.0 : d.galones / d.galonesMercado) * 100).toFixed(2)}%</td>
                                <td style={{ textAlign: 'right' }}>{d.galonesMercado - d.galones}</td>
                            </tr>
                        ))}
                    </tbody>
                    {summary.mercadoPDV > 0 && (
                        <tfoot>
                            <tr>
                                <th style={{ backgroundColor: '#5f9efc', color: 'Black' }}>TOTAL</th>
                                <th style={{ backgroundColor: '#5f9efc', color: 'Black', textAlign: 'right' }}>{Intl.NumberFormat('es-MX').format(summary.cuentaPDV)}</th>
                                <th style={{ backgroundColor: '#5f9efc', color: 'Black', textAlign: 'right' }}>{Intl.NumberFormat('es-MX').format(summary.mercadoPDV)}</th>
                                <th style={{ backgroundColor: '#5f9efc', color: 'Black', textAlign: 'right' }}>{((summary.cuentaPDV / summary.mercadoPDV) * 100).toFixed(2)}%</th>
                                <th style={{ backgroundColor: '#5f9efc', color: 'Black', textAlign: 'right' }}>{summary.mercadoPDV - summary.cuentaPDV}</th>
                                <th style={{ backgroundColor: '#ead21e', color: 'Black', textAlign: 'right' }}>{Intl.NumberFormat('es-MX').format(summary.galones)}</th>
                                <th style={{ backgroundColor: '#ead21e', color: 'Black', textAlign: 'right' }}>{Intl.NumberFormat('es-MX').format(summary.galonesMercado)}</th>
                                <th style={{ backgroundColor: '#ead21e', color: 'Black', textAlign: 'right' }}>{((summary.galones === 0 ? 0.0 : summary.galones / summary.galonesMercado) * 100).toFixed(2)}%</th>
                                <th style={{ backgroundColor: '#ead21e', color: 'Black', textAlign: 'right' }}>{summary.galonesMercado - summary.galones}</th>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
            <div className="App">{open ? <ModalContent /> : null}</div>
        </FieldSet>
    );
};

export default ReporteConstruccionList;
